var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { "data-component": "app-launcher-versions" } }, [
    _c("div", { staticClass: "title" }, [
      _vm._v(
        "\n    " + _vm._s(_vm.$t("HITL.app-launcher.versions-title")) + "\n  "
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "versions-row" },
      [
        _c("or-select", {
          attrs: {
            "data-control": "app-versions",
            "model-value": _vm.sActive.appVersion,
            options: _vm.searchOptions,
            placeholder: _vm.$t("HITL.app-launcher.versions-placeholder"),
            disabled: _vm.isDisabled,
            "enable-search": "",
          },
          on: {
            "search-change": function ($event) {
              _vm.search = $event
            },
            "update:modelValue": _vm.onVersionChange,
          },
          scopedSlots: _vm._u([
            {
              key: "optionTemplate",
              fn: function (ref) {
                var option = ref.option
                return [
                  _c("app-launcher-versions-option", {
                    attrs: {
                      version: option.label,
                      "is-initial": _vm.isInitialVersion(option),
                      "needs-data-update": _vm.needsDataUpdate(option),
                    },
                  }),
                ]
              },
            },
          ]),
        }),
        _vm._v(" "),
        _vm.showVersionSaveButton
          ? _c(
              "or-button",
              {
                attrs: { "data-button": "save-version", loading: _vm.isSaving },
                on: {
                  click: function ($event) {
                    return _vm.$emit("save")
                  },
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("HITL.common.actions.save")) +
                    "\n    "
                ),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }